/**
 * Phase K.5 (2026-08-07) — Public/tokenized billing API helper.
 *
 * A minimal axios instance for the tokenized public statement/invoice
 * endpoints. Unlike the default ``api`` instance (which auto-attaches
 * the customer/admin JWT and force-logs-out on 401), this instance:
 *   - Never sends the ``Authorization`` header.
 *   - Never redirects on 401 — the caller (public view page) handles
 *     "link expired" UX itself.
 *
 * Rationale: a logged-in customer clicking their own magic link should
 * still land on the public read-only page (not force-redirected to the
 * portal). Reusing the default ``api`` would send their JWT and could
 * confuse the backend rate-limit path.
 */
import axios from "axios";
import { API_BASE_URL } from "./api";

const publicApi = axios.create({
    baseURL: API_BASE_URL,
    // Explicitly no interceptors — bare axios.
});

export default publicApi;
